import { InternalServerError, NotFoundError } from 'utils/customError'

import type { CustomError } from 'utils/customError'

export const getCustomErrorByStatus = (
  status: number,
  path: string,
  error: Error
): CustomError => {
  let unhandledError = undefined

  switch (status) {
    case 500:
    case 503:
      unhandledError = new InternalServerError(path, error)
      break
    default:
      unhandledError = new NotFoundError(path, error)
  }

  return unhandledError
}
